export const URLs = {
  navBar: {
    chatWithARep:
      'https://hover.to/lp/hover-sdr/?utm_source=7014N000000XBK5QAO&campaignMedium=Website&campaignSource=Website%20Nav%20Bar',
    scheduleDemo:
      'https://hover.to/lp/hover-sdr/?utm_source=7014N000000XBK5QAO&campaignMedium=Website&campaignSource=Website%20Nav%20Bar',
  },
};

export const HOVER_DOWNLOAD_APP_LINK =
  'https://apps.apple.com/us/app/hover-measurements-in-3d/id942568673';
